import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import { CalendarPeriodic } from '../../types';
dayjs.extend(weekOfYear);

export function getDateString(
  date: dayjs.Dayjs,
  calendarPeriodic: CalendarPeriodic
) {
  if (calendarPeriodic === 'WEEKLY') {
    const startOfMonth = date.startOf('month');
    const weekOfMonth = Math.ceil((date.date() + startOfMonth.day()) / 7);
    return `${date.format('YYYY년 M월')} ${weekOfMonth}주차`;
  }

  return date.format('YYYY년 M월 D일');
}
